<template>
  <div>
     <div class="col-12 ">
                      <div class="row mx-0">
                      <div class="col-12 px-0 position-relative" id="Previous_sum" v-if="previous_summary.length!=0">
                      <ul class="previouslist p-0 m-0 nav nav-tabs" id="myTab"  style="background:#0d6ccd;">
                            <li class="nav-item" :class="[index==0?'active':'']" v-for="(data, index) in previous_summary" :key="index">
                              {{getFormattedDate(data.visit_date)}}
                              <a  href="javascript:void(0);" @click= "GetPreviousSummaryByDate(data.visit_date, index)" class="action-view" :style="[data.doctor_summary.length==0 ? {'pointer-events':'none',opacity:'0.5'}:{'pointer-events':'visible','opacity':1}]" data-toggle="modal" data-target="#previoussummary" ></a>
                            </li>
                            <!-- <a href="javascript:void(0)" class="table_left-btn"><i class="material-icons">keyboard_arrow_left</i></a> -->
                            <!-- <a href="javascript:void(0)" class="table_right-btn" ><i class="material-icons" >keyboard_arrow_right</i ></a> -->
                      </ul>

                    </div>
                    
                    <div v-else><p>{{$t("Noprevioussummaryfound")}}</p></div>
                    </div>
                    </div>
         
  </div>
</template>

<script>
import Axios from "axios";
// import Multiselect from "vue-multiselect";
import moment from "moment";
// import Auth from "@/common/mixins";
export default {
    
mounted(){
    this.getAllPreviousSummary();
},
data(){
    return{
        previous_summary:[],
        // selected_previous_summary:null,
        customer_id: localStorage.selectedPatientId,
        tenant_id: localStorage.tenantid,
        provider_id: JSON.parse(localStorage.loggedInUserInfo).unique_id,
        accessToken: localStorage.accesstoken,
        API_URL: process.env.VUE_APP_PYTHON_API_URL,
    }
},

methods:{
    GetPreviousSummaryByDate(visit_date,arr_index){
      // alert(visit_date);
      var self = this;
      self.$parent.selected_previous_summary = [];
      for(let i=0; i<self.previous_summary.length; i++){
        if(self.previous_summary[i].visit_date == visit_date){
          self.$parent.selected_previous_summary = self.previous_summary[i].doctor_summary;
          self.$parent.prev_summary_arr_index = arr_index;
          break;
        }
      }
    },
    // UseLine(id){
    // if( !$("#"+id).hasClass("line-selected")){
    //   $("#" + id).css("color", "black");
    //   $("#" + id).addClass("line-selected");
    //   this.$emit("SelectedLine", $('#'+id).text());
    //   }
    // },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getAllPreviousSummary() {
      var req_data = {};

      req_data.customer_id = this.customer_id;
      req_data.provider_id = this.provider_id;
      req_data.tenant_id = this.tenant_id;
      Axios.request({
        method: "post",
        url: this.API_URL + "/v2/get_provider_frequent_data",
        data: req_data,
        headers: {Authorization: this.accessToken},
      })
        .then((res) => {
          this.previous_summary = res.data.previous_summary;
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
},
}
</script>

<style>
.sum_text.tab-content{background: #ffffff;padding:10px;}
</style>